import { format, parseISO, parse, isValid, isBefore, differenceInYears } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';

/* Formato: 25 de Dezembro de 2023 */
export const formatToBrazilianExtended = (date) => {
  const formattedDate = parseISO(date);

  const day = format(formattedDate, 'dd', { locale: ptBR });
  const month = format(formattedDate, 'MMMM', { locale: ptBR });
  const year = format(formattedDate, 'yyyy', { locale: ptBR });

  const formattedDateString = `${day} de ${month.charAt(0).toUpperCase() + month.slice(1)} de ${year}`;

  return formattedDateString;
};

/* Formato: 25/12/2023 */
export const formatDayMonthYear = (dateString) => {

  if (!dateString) {
    return 'Indisponível';
  }

  const date = new Date(dateString);
  const day = date.getUTCDate().toString().padStart(2, '0');
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0'); // Note: O mês começa em 0 (janeiro) e vai até 11 (dezembro)
  const year = date.getUTCFullYear();

  return `${day}/${month}/${year}`;
};

/* Formato: 27/01/2021 às 22h30 */
export const formatDateAndTime = (date) => {
  const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/;
    if (!date) {
    return '';
  }

  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'America/Sao_Paulo',
    timeZoneName: 'short'
  };

  const dateObject = new Date(date.match(regex));
  const formatter = new Intl.DateTimeFormat('pt-BR', options);
  const formattedDate = formatter.format(dateObject).replace(/\s[A-Z]{3}$/, '');

  const [datePart, timePart] = formattedDate.split(', ');
  return `${datePart} às ${timePart}`;

};


/* Validar uma data e maior idade */
export const isAdultAndValidDate = (dateOfBirth) => {
  const birthDate = parse(dateOfBirth, 'dd/MM/yyyy', new Date());

  // Verificar se a data de nascimento é válida
  if (!isValid(birthDate)) {
    return false;
  }

  // Verificar se a data de nascimento é posterior a 1900
  const minDate = parse('01/01/1900', 'dd/MM/yyyy', new Date());
  if (isBefore(birthDate, minDate)) {
    return false;
  }

  const currentDate = new Date();

  const age = differenceInYears(currentDate, birthDate);

  return age >= 18;
};

/* Formato: 1987-06-22T00:00:00+00:00 */
export const convertStringToDate = (dateString) => {
  // A string está no formato DD/MM/YYYY
  const [day, month, year] = dateString.split('/');

  // Criar objeto de data usando date-fns
  const resultDate = parse(`${year}-${month}-${day}`, "yyyy-MM-dd", new Date());

  // Formatar a data para o formato desejado
  const formattedDate = format(resultDate, "yyyy-MM-dd'T'00:00:00XXX");

  return formattedDate;
};
